module.exports = __webpack_public_path__ + "static/media/nominal_not_zoom.b009b659.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nominal_not_zoom.png
// module id = 86
// module chunks = 0